import "./Residences.module.css";
import Header from "@/reusable_sections/Header";
import AllAvailableUnits from "./sections/AllAvailableUnits";
import NeighborhoodSpotlights from "./sections/NeighborhoodSpotlights";
import Footer from "@/reusable_sections/Footer";
export default function ResidencesPage() {
  return <div>
      <Header />
      <AllAvailableUnits />
      <NeighborhoodSpotlights />
      <Footer />
    </div>;
}